import styled from "styled-components";
import { Link } from "react-router-dom";
import Reveal from "react-awesome-reveal";
import { slideFade } from "../utils/animations";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  text-align: center;
  padding: 2rem;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 0.4)
  );
`;

const Title = styled.h1`
  font-family: "Funnel Sans", sans-serif;
  font-size: min(12rem, 25vw);
  margin: 0;
  line-height: 0.8;
  color: #333;
  opacity: 0.9;
  font-weight: 800;
`;

const Subtitle = styled.h2`
  font-family: "Funnel Sans", sans-serif;
  font-size: min(2.5rem, 6vw);
  margin: 1rem 0;
  font-weight: 600;
  color: #222;
`;

const Description = styled.p`
  font-family: "Funnel Sans", sans-serif;
  font-size: 1.25rem;
  max-width: 500px;
  margin-bottom: 3rem;
  color: #555;
  line-height: 1.6;
`;

const ButtonWrapper = styled.div`
  margin-top: 1rem;
`;

function NotFound() {
  return (
    <Container>
      <Reveal keyframes={slideFade} triggerOnce>
        <Title>404</Title>
        <Subtitle>We can’t find that page</Subtitle>
        <Description>
          The page you’re looking for doesn’t exist or may have been moved.
        </Description>
        <ButtonWrapper>
          <Link to="/" style={{ textDecoration: "none" }}>
            <button>Return Home</button>
          </Link>
        </ButtonWrapper>
      </Reveal>
    </Container>
  );
}

export default NotFound;
